import {GetAuthScheduleParams} from 'domain/usecases';
import {makeGetAuthSchedule} from 'main/factories/usecases/private/authorizations/get-auth-schedule-factory';

export const getAuthSchedule = async ({signal}: GetAuthScheduleParams) => {
	const response = await makeGetAuthSchedule().get({signal});
	return response;
};
